import React from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import { values } from 'lodash'
import { Panel, Modal, ListGroup, ListGroupItem } from 'react-bootstrap'

import Task from './Task.jsx'
import getPlansList from './plans.js'
import { getThisTripTasks } from '../selectors'
import Button from '../components/Button.jsx'

import { createTask, updateTask, removeTask, initiatePlan, Task as TaskType } from '../ducks/tasks'

import ModalTaskEditor from './ModalTaskEditor.jsx'
import { getText } from '../lib/text.js'

const Wrapper = ({ panel, children }) => (
  panel
    ? (
      <Panel>
        <Panel.Heading><h2>{getText("Tareas")}</h2></Panel.Heading>
        <Panel.Body>{children}</Panel.Body>
      </Panel>
    )
    : (
      <div>{children}</div>
    )
)

/**
 *
 */

const PickPlanModal = ({ initiatePlan, cancel }) => (
  <Modal show onHide={() => cancel()}>
    <Modal.Header><Modal.Title>{getText("Elige qué plan usar")}</Modal.Title></Modal.Header>
    <Modal.Body>
      <ListGroup>
        {
          values(getPlansList()).map(plan => (
            <ListGroupItem key={plan.key || plan.id || plan._id}>
              {plan.name}: {plan.text} ({plan.length} {getText("num_tareas")})
              <br />
              <Button onClick={() => initiatePlan(plan.id)}>
                {getText("Iniciar este plan")}
              </Button>
            </ListGroupItem>
          ))
        }
      </ListGroup>
    </Modal.Body>
    <Modal.Footer>
      <Button onClick={() => cancel()}>{getText("Cancelar")}</Button>
    </Modal.Footer>
  </Modal>
)

/**
 *
 */

type Props = {
  // from dad
  trip: Object,
  panel: ?boolean,

  // from connect
  username: string,
  initiatePlan: ( string, string, string|Object) => void, // plan, encargado, startDate
  removeTask: (string) => void,
  tripPendingTasks: Object[],
  updateTask: (string, Object) => void,
  addTask: () => void
}

class TripTasks extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = { modal: false, editingTask: null }
  }

  props: Props

  getPlanEncargado() {
    if (this.props.trip.encargado) {
      return this.props.trip.encargado
    }

    if (this.props.username) {
      if (confirm(`${getText("warning_plan_no_assign")} (${this.props.username})`)) {
        return this.props.username
      }
    }

    return null
  }

  addTask() {
    if (!this.props.trip.encargado) alert(getText("no_encargado"))
    else {
      this.props.addTask(id => {
        this.openTask(id)
      })
    }
  }

  openTask(id) {
    this.setState({ editingTask: id })
  }

  renderTasks(tasks : TaskType, active: boolean, username: string) {
    return (
      tasks.length == 0
        ? (<em>{getText("0 tareas")}</em>)
        : tasks.map(task => (
          <Task
            includeTrip={false}
            key={`${task._id}`}
            task={task}
            onChange={changes => this.props.updateTask(task._id, changes)}
            onEdit={() => this.openTask(task._id)}
            active={active && task.user === username && task.status == 'pending'}
          />
        ))
    )
  }

  render() {
    const { username, tripPendingTasks, initiatePlan } = this.props
    const today = moment().format("YYYY/MM/DD")
    const tomorrow = moment().add(1, "days").format("YYYY/MM/DD")

    const editingTask = this.state.editingTask && tripPendingTasks.find(t => t._id == this.state.editingTask)

    return (
      <Wrapper panel={this.props.panel}>
        <ListGroup>
          <h4>{getText("Tareas pasadas")}</h4>
          { this.renderTasks(tripPendingTasks.filter(task => task.dueDate < today), true, username) }
          <h4>{getText("Tareas de hoy")}</h4>
          { this.renderTasks(tripPendingTasks.filter(task => task.dueDate == today), true, username) }
          <h4>{getText("Tareas de mañana")}</h4>
          { this.renderTasks(tripPendingTasks.filter(task => task.dueDate == tomorrow), false, username) }
          <h4>{getText("Tareas posteriores")}</h4>
          { this.renderTasks(tripPendingTasks.filter(({dueDate}) => !dueDate || dueDate > tomorrow), false, username) }
        </ListGroup>

        {
          editingTask
            ? (
              <ModalTaskEditor
                task={editingTask}
                onChange={changes => this.props.updateTask(this.state.editingTask, changes)}
                onRemove={() => this.props.removeTask(this.state.editingTask)}
                onClose={() => this.setState({ editingTask: null })}
              />
            )
            : ""
        }

        <Button
          glyph="plus"
          onClick={() => this.addTask()}
        >
          {getText("Añadir tarea")}
        </Button>

        {
          this.state.modal
            ? (
              <PickPlanModal
                initiatePlan={p => {
                  const encargado = this.getPlanEncargado()
                  if (encargado) {
                    initiatePlan(p, encargado, moment())
                  }
                  this.setState({ modal: false })
                }}
                cancel={() => this.setState({ modal: false })}
              />
            )
            : null
        }
      </Wrapper>
    )
  }
}

const stateToProps = (state, props) => ({
  tripPendingTasks: getThisTripTasks(state, props),
  username: state.loginData.username
})

const dispatchToProps = (dispatch, props) => ({
  initiatePlan: (planId, encargado, startDate) => dispatch(initiatePlan(props.trip._id, planId, encargado, startDate)),
  removeTask: (id) => dispatch(removeTask(id)),
  updateTask: (id, changes) => dispatch(updateTask(id, changes)),
  addTask: cb => {
    if (!props.trip.encargado) alert(getText("no_encargado"))
    else {
      dispatch(
        createTask(
          { trip: props.trip._id, user: props.trip.encargado},
          id => cb && cb(id)
        )
      )
    }
  }
})

export default connect(stateToProps, dispatchToProps)(TripTasks)
